export const getPreselectedUnit = async (): Promise<string> => {
  let unitID = ''
  try {
    if (window?.ikea?.store) {
      unitID = await window.ikea.store.get()
    }
  } catch (error) {
    console.error(error)
  }
  return unitID
}
